module.exports = __webpack_public_path__ + "mz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mz.svg
// module id = 719
// module chunks = 0